import { router } from '@inertiajs/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faGauge, faFileLines, faGear,
  faXmark, faRightFromBracket, faUser, faFileShield, faBell
} from '@fortawesome/free-solid-svg-icons'
import logo from '../../../assets/images/logo-nav-foo-bar.png'

const NAV_ITEMS = [
  { icon: faGauge,           label: 'Dashboard',      href: '/user/dashboard' },
  { icon: faFileLines,       label: 'Laporan Saya',   href: '/user/reports',     matchPath: '/user/reports' },
  { icon: faBell,            label: 'Notifikasi',     href: '/user/notifications', matchPath: '/user/notifications' },
  { icon: faFileShield,      label: 'Verifikasi PKS', href: '/user/verify_pks',  matchPath: '/user/verify_pks' },
  { icon: faGear,            label: 'Pengaturan',     href: '/user/settings',    matchPath: '/user/settings' },
]

export default function UserSidebar({ current_user, open, onClose }) {
  const logout = () => { if (confirm('Yakin ingin keluar?')) router.delete('/logout') }

  const isActive = (item) => {
    const path = window.location.pathname
    const compareTo = item.matchPath ?? item.href.split('?')[0]
    return path === compareTo
  }

  return (
    <>
      {open && <div className="fixed inset-0 z-20 bg-black/40 lg:hidden" onClick={onClose} />}
      <aside className={`fixed lg:static inset-y-0 left-0 z-30 w-64 bg-white border-r border-gray-200 flex flex-col transition-transform duration-200 ${open ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}>
        <div className="flex items-center gap-3 px-5 h-16 border-b border-gray-100">
          <img src={logo} className="h-8 w-auto" alt="WBS" />
          <div>
            <div className="text-sm font-bold text-gray-800 leading-none">WBS Kalsel</div>
            <div className="text-[10px] text-gray-400 mt-0.5">Portal Pengguna</div>
          </div>
          <button className="ml-auto lg:hidden text-gray-400" onClick={onClose}>
            <FontAwesomeIcon icon={faXmark} className="w-4 h-4" />
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-0.5">
          <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest px-3 mb-2">Menu Utama</p>
          {NAV_ITEMS.map(item => (
            <a key={item.label} href={item.href}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive(item) ? 'bg-green-50 text-green-700' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'}`}>
              <FontAwesomeIcon icon={item.icon} className="w-4 h-4 flex-shrink-0" />
              <span className="flex-1">{item.label}</span>
            </a>
          ))}
        </nav>

        <div className="border-t border-gray-100 p-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0">
              <FontAwesomeIcon icon={faUser} className="w-4 h-4 text-green-600" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-gray-800 truncate">{current_user?.name || 'Pengguna'}</div>
              <div className="text-[11px] text-gray-400 truncate">{current_user?.email}</div>
            </div>
            <button onClick={logout} className="text-gray-400 hover:text-red-500 transition-colors" title="Keluar">
              <FontAwesomeIcon icon={faRightFromBracket} className="w-4 h-4" />
            </button>
          </div>
        </div>
      </aside>
    </>
  )
}
